/* global google */
import React, { Component } from "react";
import moment from "moment";
import {
  Menu,
  Dropdown,
  Row,
  Col,
  Icon,
  Input,
  Typography,
  Divider,
  Switch,
  Card,
  Checkbox,
  Spin,
  Button,
  Badge,
  Modal,
  Tooltip,
  Radio,
  notification,
} from "antd";
import { withRouter } from "react-router";
import queryString from "query-string";
import { isEqual, last, debounce, pick } from "lodash";
import PlacesAutocomplete, {
  geocodeByAddress,
} from "react-places-autocomplete";
import MapFiltersComponent from "./MapFiltersComponent";

import MapHolder from "./Styles/mapStyle";
import SelectionFiltersContainer from "../containers/SelectionFiltersContainer";
import CartContainer from "../containers/CartContainer";
import CartAudienceContainer from "../containers/CartAudienceContainer";

import { ResultsMap } from "./ResultsMap";
import DisplayMapList from "./features/map_view/components/DisplayMapList";
import TableResultsMap from "./features/map_view/components/TableResultsMap";
import CartTableSummaryButton from "./features/map_view/components/CartTableSummaryButton";
import BundlesAddedModal from "./features/map_view/components/BundlesAddedModal";

import {
  convertBounds,
  adaptParams,
  updateParams,
  getDisplaysIdsFromMap,
} from "../services/display";

import { withTranslation } from "react-i18next";
import { hasAccessRole } from "../services/utils";
import UserRoleEnum from "../constants/UserRoleEnum";
import { getMinimunByCurrency } from "../services/utils";
import Colors from "../themes/Colors";
import { saveAs } from "file-saver";
import UrlEnum from "../constants/UrlEnum";
import { getDomain } from "../services/utils";
import { ErrorBoundary } from "react-error-boundary";
import CriticalErrorFallbackComponent from "./ErrorFallbacks";
import RefinateFiltersContainer from "../containers/RefinateFiltersContainer";
import AddDisplaysByIdModal from "./AddDisplaysByIdModal";
import { expandVenueSelection } from "../services/venueCategories";

const CheckSearch = Card;

// Static JSX elements kept at module scope so we pass the same reference to
// ResultsMap on every render — avoids withGoogleMap treating these as new
// children every time the parent re-renders (e.g. on hover).
const RESULTS_MAP_LOADING_ELEMENT = <div style={{ height: "100%" }} />;
const RESULTS_MAP_ELEMENT_BORDERED = (
  <div style={{ height: "100%", borderRadius: "16px" }} />
);
// Price filter (from the refine form) persisted in the URL.
const PRICE_URL_KEYS = ["price_min", "price_max", "price_filter_strategy"];

const RESULTS_MAP_CONTAINER_DESKTOP = <div className="mapHeight" />;
const RESULTS_MAP_CONTAINER_MOBILE = <div className="mapHeightMobile" />;

class MapComponent extends Component {
  constructor(props) {
    super(props);
    const params = queryString.parse(props.history.location.search, {
      arrayFormat: "bracket",
    });
    props.setParamsFromUrl(adaptParams(params));

    this.debouncedRefreshDisplaysForUrlSync = debounce(
      (page) => this.refreshDisplays(null, page),
      1000,
    );
    this.debouncedRefreshDisplaysForSearch = debounce(
      () => this.refreshDisplays(),
      500,
    );
    this.state = {
      hoverDisplay: null,
      currentDisplay: null,
      address: "",
      searchPlace: "",
      redirect: false,
      relocateMap: false,
      searchLocation: false,
      isProgrammaticFilterHidden: true,
      latitude: (this.props.lat_sw + this.props.lat_ne) / 2,
      longitude: (this.props.lng_sw + this.props.lng_ne) / 2,
      isMobile: window.innerWidth < 576,
      errors: {},
      search: null,
      setProgrammatic: false,
      arrayPolygon: [],
      shouldClearPolygons: false,
      checkSearchMap: true,
      companiesOfWhiteBrand: null,
      domain: getDomain(window.location.hostname),
      advancedFilters: pick(params, PRICE_URL_KEYS),
      showFiltersModal: false,
      showAddByIdModal: false,
      viewMode: "map",
      cartDrawerVisible: false,
      mapSort: null,
      mapSortDir: "asc",
      bundlesAdded: null,
    };
  }

  bulkListBundleSnapshot = null;
  clusterListBundleSnapshot = null;

  handleBulkDisplaysCart = (params) => {
    this.bulkListBundleSnapshot = this.props.listBundle || [];
    this.props.getBulkDisplaysCart(params);
  };

  getCartBundlesByIds = (bundleIds) => {
    const found = new Map();

    (this.props.cart || []).forEach((display) => {
      (display.bundles || []).forEach((bundle) => {
        if (bundleIds.includes(bundle.id) && !found.has(bundle.id)) {
          found.set(bundle.id, bundle);
        }
      });
    });

    return [...found.values()];
  };

  showBundlesAddedIfAny = (snapshot) => {
    const addedIds = (this.props.listBundle || []).filter(
      (id) => !snapshot.includes(id),
    );
    const bundlesAdded = addedIds.length
      ? this.getCartBundlesByIds(addedIds)
      : [];

    if (bundlesAdded.length > 0) this.setState({ bundlesAdded });
  };

  handleCloseBundlesAddedModal = () => {
    this.setState({ bundlesAdded: null });
  };

  handleTableSortChange = (sort, sortDir) => {
    this.setState(
      { mapSort: sort, mapSortDir: sortDir || "asc" },
      () => this.refreshDisplays(null, null, {}, true),
    );
  };

  handleOpenCartDrawer = () => {
    this.setState({ cartDrawerVisible: true });
  };

  handleCloseCartDrawer = () => {
    this.setState({ cartDrawerVisible: false });
  };

  setAdvancedFilters = (filters) => {
    this.setState({ advancedFilters: filters, showFiltersModal: false }, () => {
      this.refreshDisplays();
    });
    const params = queryString.parse(this.props.history.location.search, {
      arrayFormat: "bracket",
    });
    PRICE_URL_KEYS.forEach((key) => {
      if (filters[key] === undefined) delete params[key];
      else params[key] = filters[key];
    });
    this.props.history.replace(
      "/map?" + queryString.stringify(params, { arrayFormat: "bracket" }),
    );
  };

  pruneMediaOwnerFilter = () => {
    const { advancedFilters } = this.state;
    if (!advancedFilters.company_list_ids) return;
    const available = new Set(this.props.displaysMapMediaOwners.map((o) => o.id));
    const ids = advancedFilters.company_list_ids.split(",").map(Number);
    const kept = ids.filter((id) => available.has(id));
    if (kept.length === ids.length) return;

    const { company_list_ids, ...rest } = advancedFilters;
    this.setState({
      advancedFilters: kept.length
        ? { ...rest, company_list_ids: kept.join(",") }
        : rest,
    });
  };

  handleShowFiltersModal = () => {
    this.setState({ showFiltersModal: true });
  };

  handleCancelFiltersModal = () => {
    this.setState({ showFiltersModal: false });
  };

  handleOpenAddByIdModal = () => {
    this.setState({ showAddByIdModal: true });
  };

  handleCloseAddByIdModal = () => {
    this.setState({ showAddByIdModal: false });
  };

  handleChangeAddress = (address) => {
    this.setState({ address });
  };

  setCheckSearchMap = (e) => {
    let value = !e.target.value;
    this.setState({ checkSearchMap: value });
  };

  handleChangeViewMode = (e) => {
    this.setState({ viewMode: e.target.value });
  };

  handleSelectAddress = (address) => {
    // Picking a location always shows the result on the map, so switch back
    // from the table view automatically.
    this.setState({ address, viewMode: "map" });
    return geocodeByAddress(address)
      .then((results) => {
        if (results) {
          const coords = convertBounds(results[0].geometry.viewport);
          this.props.setCoords(coords);
          if (results[0].types[0] === "continent") {
            this.props.setMapZoom(2);
          } else if (results[0].types[0] === "country") {
            this.props.setMapZoom(5);
          } else if (results[0].types[0] === "administrative_area_level_1") {
            this.props.setMapZoom(7);
          } else if (results[0].types[0] === "administrative_area_level_2") {
            this.props.setMapZoom(9);
          } else if (results[0].types[0] === "colloquial_area") {
            this.props.setMapZoom(11);
          } else if (results[0].types[0] === "locality") {
            this.props.setMapZoom(12);
          } else if (
            results[0].types[0] === "political" ||
            (results[0].lenght > 1 && results[0].types[1] === "sublocality")
          ) {
            this.props.setMapZoom(14);
          } else if (
            results[0].types[0] === "intersection" ||
            results[0].types[0] === "street_address" ||
            results[0].types[0] === "street_number" ||
            results[0].types[0] === "route"
          ) {
            this.props.setMapZoom(18);
          } else if (
            results[0].types[0] === "establishment" ||
            results[0].types[0] === "point_of_interest" ||
            results[0].types[0] === "shopping_mall"
          ) {
            this.props.setMapZoom(16);
          }
        }
        this.setState({ relocateMap: true });
        setTimeout(() => {
          this.setState({
            searchLocation: true,
          });
          this.refreshDisplays();
        }, 300);
      })
      .catch((error) => console.error("Error", error));
  };

  handleSelectPlace = (typedPlace) => {
    this.setState({ searchPlace: typedPlace });
  };

  // updateCenter(lat, lng) {
  //   this.setState({
  //     latitude: lat,
  //     longitude: lng,
  //   });
  // }

  hoverDisplay = (display) => {
    this.setState({ hoverDisplay: display });
  };

  setSearch = (value) => {
    this.setState({ search: value });
    this.debouncedRefreshDisplaysForSearch();
  };

  searchDisplays = (e) => {
    this.setSearch(e.target.value);
  }

  openDisplay = (display) => {
    this.setState({ currentDisplay: display });
  }

  closeDisplay = () => {
    this.setState({ currentDisplay: null });
  }

  componentDidMount() {
    this.props.resetPoiFilters();
    const params = queryString.parse(this.props.location.search, {
      arrayFormat: "bracket",
    });

    if (
      !params.displays_list &&
      this.props.cart.length > 0 &&
      (this.props.cart[0].currency != this.props.currency ||
        (this.props.editCampaignActive &&
          this.props.cart[0].currency != this.props.campaignCurrency))
    ) {
      this.updateCartByCurrency();
    }
    if (!this.props.user) {
      this.props.setShouldPromptLogin(true, null);
    }


    const urlProgrammatic =
      params.programmatic === "programmatic" || params.programmatic === "true"
        ? "programmatic"
        : "traditional";
    const urlIsGuaranteed =
      params.isGuaranteed === "true" || params.is_guaranteed === "true";
    if (urlProgrammatic === "programmatic") {
      this.props.setProgrammatic("programmatic");
    }
    if (urlIsGuaranteed) {
      this.props.setIsGuaranteed(true);
    }
    if (params.budget) {
      this.props.setBudget(params.budget);
    }
    if (params.displays_list) {
      this.updateCartByDisplaysList(params.displays_list, {
        programmatic: urlProgrammatic,
        date_from: params.date_from,
        date_to: params.date_to,
      });
    }

    // When the domain is smartfit or duoprint, it only needs to fetch the screens for that company.
    const domainMappings = {
      smartFit: UrlEnum.companiesSmartfit,
      duoPrint: UrlEnum.companiesDuoPrint,
    };

    let listDomian = ["smartFit", "duoPrint"];
    let domain = getDomain(window.location.hostname);

    if (listDomian.includes(this.state.domain)) {
      const listCompanies = domainMappings[domain];
      this.setState({ companiesOfWhiteBrand: listCompanies });
    }
  }

  updateCartByDisplaysList(displays_list, overrides = {}) {
    const arrayDisplays = displays_list.split(",");
    this.updateCart(arrayDisplays, "url", overrides);
  }

  updateCartByCurrency() {
    const { cart } = this.props;
    const list_id = cart.map((item) => item.id);
    this.updateCart(list_id);
  }

  updateCart(list_display, origin = null, overrides = {}) {
    if (this.props.cart.length === 0 && origin !== "url") return;
    const {
      date_from,
      date_to,
      currency,
      invoiceIssuingCountry,
      client,
      programmatic,
      dsp,
      editCampaignActive,
      campaignCurrency,
      campaignInvoiceIssuingCountry,
    } = this.props;
    const effectiveProgrammatic =
      overrides.programmatic !== undefined
        ? overrides.programmatic
        : programmatic;

    const effectiveDateFrom = overrides.date_from || date_from;
    const effectiveDateTo = overrides.date_to || date_to;

    this.props.getDisplaysCart({
      date_from: moment(effectiveDateFrom || new Date()).format("YYYY-MM-DD"),
      date_to: moment(effectiveDateTo || new Date()).format("YYYY-MM-DD"),
      currency: editCampaignActive ? campaignCurrency : currency,
      invoice_issuing_country: editCampaignActive
        ? campaignInvoiceIssuingCountry
        : invoiceIssuingCountry,
      client_id: client ? client.id : null,
      list_id: list_display,
      external_dsp_id: dsp ? dsp.id : null,
      smart_campaign_enabled:
        effectiveProgrammatic === "programmatic" ? 1 : null,
      is_campaign: editCampaignActive ? 1 : 0,
    });
  }

  // When limits change, it sets page to 1.
  // When only page changes, the state doesn't change.
  settingPageWhenChangeBounds(prevProps) {
    const { lat_sw, lng_sw, lat_ne, lng_ne, page } = this.props;
    const {
      lat_sw: prevLatSw,
      lng_sw: prevLngSw,
      lat_ne: prevLatNe,
      lng_ne: prevLngNe,
      prevPage,
    } = prevProps;

    let pageAux = page;
    if (
      lat_ne !== prevLatNe ||
      lng_ne !== prevLngNe ||
      lat_sw !== prevLatSw ||
      lng_sw !== prevLngSw
    ) {
      pageAux = 1;
      this.props.setPage(pageAux);
    }

    return pageAux;
  }

  componentDidUpdate(prevProps, prevState) {
    const currentCurrency =
      this.props.editCampaignActive && this.props.campaignCurrency
        ? this.props.campaignCurrency
        : this.props.currency;
    const prevCurrency =
      prevProps.editCampaignActive && prevProps.campaignCurrency
        ? prevProps.campaignCurrency
        : prevProps.currency;
    //download excel
    if (prevProps.loadingExcel && this.props.excelDisplay) this.downloadExcel();

    // A bulk cart fetch just finished: if it added sales bundles, list them.
    if (this.bulkListBundleSnapshot && prevProps.fetching && !this.props.fetching) {
      const snapshot = this.bulkListBundleSnapshot;
      this.bulkListBundleSnapshot = null;
      this.showBundlesAddedIfAny(snapshot);
    }

    if (
      this.clusterListBundleSnapshot &&
      prevProps.clusterPolygonLoading &&
      !this.props.clusterPolygonLoading
    ) {
      const snapshot = this.clusterListBundleSnapshot;
      this.clusterListBundleSnapshot = null;
      this.showBundlesAddedIfAny(snapshot);

      if (this.props.clusterPolygonHadErrors) {
        notification.warning({
          message: this.props.t("Some screens could not be added"),
        });
      }
    }

    if (this.props.redirectTarget) {
      return;
    }
    // Get parameters from the URL when creating a proposal
    const urlParams = queryString.parse(this.props.history.location.search, {
      arrayFormat: "bracket",
    });
    const oldParams = {
      ...adaptParams(urlParams),
      ...pick(urlParams, PRICE_URL_KEYS),
    };

    const changedTheBrand =
      prevProps.brand &&
      this.props.brand.id &&
      prevProps.brand.id != this.props.brand.id;

    if (prevProps.showAllDisplays != this.props.showAllDisplays || changedTheBrand)
      this.refreshDisplays();

    // The first taxonomy came with results the category filter could not narrow yet.
    if (
      !prevProps.venueTypes.length &&
      this.props.venueTypes.length &&
      this.props.location_sub_type.length
    )
      this.refreshDisplays();

    let dspId = this.props.dsp ? this.props.dsp.id : null;
    if (
      oldParams.external_dsp_id &&
      oldParams.external_dsp_id !== "null" &&
      oldParams.external_dsp_id != dspId
    ) {
      let paramsDsp = parseInt(oldParams.external_dsp_id);
      const foundDsp = this.props.dsps.find((dsp) => dsp.id === paramsDsp);
      if (foundDsp) {
        this.props.setDsp(foundDsp);
      }
    } else if (
      (oldParams.external_dsp_id === "null" ||
        oldParams.external_dsp_id === null) &&
      dspId !== null
    ) {
      this.props.setDsp(null);
    }

    if (
      ((prevCurrency != currentCurrency || prevProps.dsp != this.props.dsp) &&
        this.props.cart.length > 0) ||
      changedTheBrand
    ) {
      this.updateCartByCurrency();
    }

    const pageAux = this.settingPageWhenChangeBounds(prevProps);

    if (
      prevProps.displaysMapMediaOwners !== this.props.displaysMapMediaOwners
    ) {
      this.pruneMediaOwnerFilter();
    }

    const urlSyncInputsChanged =
      prevProps.lat_sw !== this.props.lat_sw ||
      prevProps.lng_sw !== this.props.lng_sw ||
      prevProps.lat_ne !== this.props.lat_ne ||
      prevProps.lng_ne !== this.props.lng_ne ||
      prevProps.date_from !== this.props.date_from ||
      prevProps.date_to !== this.props.date_to ||
      prevProps.shows_per_day_min !== this.props.shows_per_day_min ||
      prevProps.location_type !== this.props.location_type ||
      prevProps.location_sub_type !== this.props.location_sub_type ||
      prevProps.size_type !== this.props.size_type ||
      prevProps.isCircuit !== this.props.isCircuit ||
      prevProps.page !== this.props.page ||
      prevProps.programmatic !== this.props.programmatic ||
      prevProps.isGuaranteed !== this.props.isGuaranteed ||
      prevCurrency !== currentCurrency;

    if (!urlSyncInputsChanged) {
      return;
    }

    const newParams = updateParams(oldParams, {
      date_from: moment(this.props.date_from || new Date()).format(
        "YYYY-MM-DD",
      ),
      date_to: moment(this.props.date_to || new Date()).format("YYYY-MM-DD"),
      lat_sw: this.props.lat_sw,
      lng_sw: this.props.lng_sw,
      lat_ne: this.props.lat_ne,
      lng_ne: this.props.lng_ne,
      shows_per_day_min: this.props.shows_per_day_min,
      location_type: this.props.location_type,
      location_sub_type: this.props.location_sub_type,
      size_type: this.props.size_type,
      is_circuit: this.props.isCircuit,
      page: pageAux,
      currency: currentCurrency,
      programmatic: this.props.programmatic === "programmatic" ? "programmatic" : "traditional",
      is_guaranteed: this.props.isGuaranteed ? "1" : "0",
    });
    oldParams.currency = prevCurrency;
    oldParams.location_type = oldParams.location_type || [];
    oldParams.location_sub_type = oldParams.location_sub_type || [];
    oldParams.size_type = oldParams.size_type || [];
    oldParams.is_circuit = prevProps.isCircuit;
    oldParams.programmatic =
      prevProps.programmatic === "programmatic" ? "programmatic" : "traditional";
    oldParams.is_guaranteed = prevProps.isGuaranteed ? "1" : "0";
    if (isEqual(oldParams, newParams)) {
      return;
    }

    this.debouncedRefreshDisplaysForUrlSync(pageAux);
    this.props.history.replace(
      "/map?" + queryString.stringify(newParams, { arrayFormat: "bracket" }),
    );
  }

  handleAmountChange(e) {
    this.props.setBudget(e.target.value);
    this.checkMinimumBudget(e);
  }

  checkMinimumBudget(e) {
    const currentCurrency =
      this.props.editCampaignActive && this.props.campaignCurrency
        ? this.props.campaignCurrency
        : this.props.currency;
    const errors = {};
    const minimun = getMinimunByCurrency(currentCurrency);
    if (parseInt(e.target.value) < minimun) {
      errors["budget"] = this.props.t("Minumum budget") + minimun;
    }
    this.setState({ errors });
  }

  getCompanies() {
    const { user, showAllDisplays: allDisplays } = this.props;
    const { companiesOfWhiteBrand } = this.state;

    // if (this.props.cart.length > 0) return null

    if (companiesOfWhiteBrand) {
      return companiesOfWhiteBrand;
    }

    if (user && user.roles) {
      const hasCompanyAccess =
        hasAccessRole(user.roles, [UserRoleEnum.companyMember]) && !allDisplays;

      // The agency is in the media holding with other companies of type media company
      const hasAgencyAccess =
        hasAccessRole(user.roles, [UserRoleEnum.agencyMember]) &&
        user.is_in_media_holding &&
        !allDisplays;

      if (hasCompanyAccess || hasAgencyAccess) {
        return [user.company.id];
      }
    }
    return null;
  }

  refreshDisplays = (poiFilters = null, page = null, extraFilters = {}, force = false) => {
    const { poi_filters, editCampaignActive, isGuaranteed } = this.props;
    const { companiesOfWhiteBrand, advancedFilters } = this.state;
    
    if (!this.state.checkSearchMap && !force) {
      return;
    }

    const pageAux = page || this.props.page;

    // Check if poi_filters is null, if it is, use the one in the state
    poiFilters = poiFilters || poi_filters;

    if (!this.props.user) {
      this.props.setShouldPromptLogin(true, null);
    } else {
      const apiParams = {
        date_from: moment(this.props.date_from || new Date()).format(
          "YYYY-MM-DD",
        ),
        date_to: moment(this.props.date_to || new Date()).format("YYYY-MM-DD"),
        lat_sw: this.props.lat_sw,
        lng_sw: this.props.lng_sw,
        lat_ne: this.props.lat_ne,
        lng_ne: this.props.lng_ne,
        search: this.state.search,
        shows_per_day_min: this.props.shows_per_day_min,
        location_type: this.props.location_type,
        // The URL keeps the selection; the API needs every node of the subtrees.
        location_sub_type: expandVenueSelection(
          this.props.location_sub_type,
          this.props.venueTypes,
        ),
        size_type: this.props.size_type,
        is_circuit: this.props.isCircuit,
        custom_poi_type: poiFilters,
        page: pageAux,
        client_id: this.props.client ? this.props.client.id : null,
        countries: this.props.countries,
        currency: editCampaignActive
          ? this.props.campaignCurrency
          : this.props.currency,
        external_dsp_id: this.props.dsp ? this.props.dsp.id : null,
        invoice_issuing_country: editCampaignActive
          ? this.props.campaignInvoiceIssuingCountry
          : this.props.invoiceIssuingCountry,
        smart_campaign_enabled:
          this.props.programmatic && this.props.programmatic === "programmatic"
            ? 1
            : null,
        is_guaranteed: isGuaranteed ? 1 : 0,
        company_id: this.getCompanies(),
        is_campaign: editCampaignActive ? 1 : 0,
        new_version: true,
        ...(this.state.mapSort
          ? { sort: this.state.mapSort, sort_dir: this.state.mapSortDir }
          : {}),
      };

      const finalAdvancedFilters = { ...advancedFilters, ...extraFilters };
      const finalParams = {
        ...apiParams,
        ...finalAdvancedFilters,
        price_filter_strategy:
          this.props.programmatic === "traditional" ? "day" : "cpm_impressions",
      };
      this.props.getDisplaysMap(finalParams);
    }
  }

  // Markers come from the lightweight /displays/map payload, so adding one
  // directly would push an incomplete display into the cart. Instead we re-fetch
  // the full display from /displays/results with the same params the screen list
  // uses (see useDisplayMapList), guaranteeing the cart item is identical to the
  // one added from a ScreenCard — complete CPM, audience, etc.
  handleAddDisplayFromMap = (display) => {
    this.props.addDisplayToCartById(this.buildCartFetchParams([display.id]));
  };

  // Params shared by every /displays/results fetch that hydrates cart items
  // (single marker, polygon selection), mirroring the chunk fetch in
  // useDisplayMapList so the screens are priced/filtered identically.
  buildCartFetchParams = (list_id, extra = {}) => {
    const { editCampaignActive, isGuaranteed } = this.props;

    return {
      list_id,
      date_from: moment(this.props.date_from || new Date()).format("YYYY-MM-DD"),
      date_to: moment(this.props.date_to || new Date()).format("YYYY-MM-DD"),
      currency: editCampaignActive
        ? this.props.campaignCurrency
        : this.props.currency,
      invoice_issuing_country: editCampaignActive
        ? this.props.campaignInvoiceIssuingCountry
        : this.props.invoiceIssuingCountry,
      client_id: this.props.client ? this.props.client.id : null,
      external_dsp_id: this.props.dsp ? this.props.dsp.id : null,
      smart_campaign_enabled:
        this.props.programmatic === "programmatic" ? 1 : null,
      is_campaign: editCampaignActive ? 1 : 0,
      is_guaranteed: isGuaranteed ? 1 : 0,
      ...extra,
    };
  };

  handleBoostBanner = () => {
    this.setState((prevState) => ({
      showBoost: !prevState.showBoost,
    }));
  };

  mapRelocated = () => {
    this.setState({ relocateMap: false });
  };

  searchLocationOff = () => {
    this.setState({ searchLocation: false });
  };

  toggleAllDisplays = () => {
    this.props.setShowAllDisplays(!this.props.showAllDisplays);
  };

  updateArrayPolygon = (array) => {
    this.setState({
      arrayPolygon: [...this.state.arrayPolygon, ...array],
    });
  };

  handleAddDisplaysFromPolygon = (selectedDisplays) => {
    const selectedIds = (selectedDisplays || []).map((d) => d.id);
    if (selectedIds.length === 0) return;
    const cartIds = this.props.cart.map((item) => item.id);
    const list_id = [...new Set([...cartIds, ...selectedIds])];
    // Bulk fetch (same path as the table's "select all"): a `bundle_only` screen
    // inside the polygon pulls in every screen of its sales bundles, and
    // `fetching: true` lets componentDidUpdate detect the end of the round-trip
    // to list the added bundles in the alert.
    this.handleBulkDisplaysCart(
      this.buildCartFetchParams(list_id, { fetching: true }),
    );
  };

  handleAddClusterDisplaysFromPolygon = (ids) => {
    if (!ids || ids.length === 0) return;
    this.clusterListBundleSnapshot = this.props.listBundle || [];
    this.props.addClusterPolygonDisplays(this.buildCartFetchParams(ids));
  };

  // Bundle siblings are dropped by the reducer, the same way the table's bulk
  // deselection works.
  handleRemoveDisplaysFromPolygon = (displayIds) => {
    const ids = displayIds || [];
    if (ids.length === 0) return;
    this.props.removeDisplayFromCartBulk(ids);
    this.setState((state) => ({
      arrayPolygon: state.arrayPolygon.filter(
        (display) => !ids.includes(display.id),
      ),
    }));
  };

  cleanArrayPolygon = () => {
    this.setState({ arrayPolygon: [], shouldClearPolygons: true });
  };

  // Lowered by the map control once it wiped the areas, so the next request is
  // a fresh false -> true transition.
  handlePolygonsCleared = () => {
    this.setState({ shouldClearPolygons: false });
  };

  cleanFilters = () => {
    this.props.setSizeType([]);
    this.props.setLocationType([]);
    this.props.setLocationSubType([]);
  };

  downloadExcel = () => {
    const { excelDisplay } = this.props;
    saveAs(excelDisplay, "DisplaysLatinAd");
  };

  alertBadge = () => {
    const {
      size_type,
      location_type,
      location_sub_type,
      countries,
      isCircuit,
      programmatic,
    } = this.props;
    const { advancedFilters } = this.state;
    let count = 0;
    count += size_type.length;
    count += location_type.length;
    count += location_sub_type.length;
    if (countries.length > 0) count++;
    if (isCircuit) count++;
    if (advancedFilters) {
      if (advancedFilters.resolution_width) count++;
      if (
        advancedFilters.allowed_formats &&
        advancedFilters.allowed_formats.length > 0
      )
        count++;
      if (
        advancedFilters.price_min !== undefined ||
        advancedFilters.price_max !== undefined
      ) {
        if (
          programmatic === "traditional" ||
          (advancedFilters.price_min !== undefined &&
            advancedFilters.price_min !== "") ||
          (advancedFilters.price_max !== undefined &&
            advancedFilters.price_max !== "")
        )
          count++;
      }
      const defMin = 5000;
      const defMax = 50000;
      if (advancedFilters.duration_min && advancedFilters.duration_max) {
        if (
          advancedFilters.duration_min > defMin ||
          advancedFilters.duration_max < defMax
        ) {
          count++;
        }
      }
      if (advancedFilters.company_list_ids) {
        count += advancedFilters.company_list_ids.split(",").length;
      }
      if (
        advancedFilters.resolutionSelect &&
        advancedFilters.resolutionSelect.length > 0
      )
        count++;
      if (advancedFilters.customResolution) count++;
    }
    return count;
  };

  // Cached factory for the bounds object passed to both ResultsMap instances.
  // ResultsMap is deep inside react-google-maps HOCs that re-render on any
  // prop identity change; returning the same reference when coords haven't
  // moved keeps the Google Map stable.
  getStableBounds() {
    const { lat_sw, lng_sw, lat_ne, lng_ne } = this.props;
    const cached = this._stableBounds;
    if (
      cached &&
      cached.south === lat_sw &&
      cached.west === lng_sw &&
      cached.north === lat_ne &&
      cached.east === lng_ne
    ) {
      return cached;
    }
    this._stableBounds = {
      south: lat_sw,
      west: lng_sw,
      north: lat_ne,
      east: lng_ne,
    };
    return this._stableBounds;
  }

  getStableCenter() {
    const { latitude, longitude } = this.state;
    const cached = this._stableCenter;
    if (cached && cached.lat === latitude && cached.lng === longitude) {
      return cached;
    }
    this._stableCenter = { lat: latitude, lng: longitude };
    return this._stableCenter;
  }

  getStableDefaultCenter() {
    const { lat_sw, lng_sw, lat_ne, lng_ne } = this.props;
    const lat = (lat_sw + lat_ne) / 2;
    const lng = (lng_sw + lng_ne) / 2;
    const cached = this._stableDefaultCenter;
    if (cached && cached.lat === lat && cached.lng === lng) {
      return cached;
    }
    this._stableDefaultCenter = { lat, lng };
    return this._stableDefaultCenter;
  }

  // Avoid running getDisplaysIdsFromMap twice in render for the count label.
  getDisplaysIdsLength() {
    const { displaysMap, displaysMapMode } = this.props;
    const cached = this._displaysIdsLenCache;
    if (
      cached &&
      cached.displaysMap === displaysMap &&
      cached.displaysMapMode === displaysMapMode
    ) {
      return cached.length;
    }
    const length = getDisplaysIdsFromMap(displaysMap, displaysMapMode).length;
    this._displaysIdsLenCache = { displaysMap, displaysMapMode, length };
    return length;
  }

  /* Controles de vista (switch "Mostrar todas" y selector Mapa/Tabla).
     Extraidos a metodos para poder usar los mismos en escritorio y en mobile,
     donde antes no se renderizaban. */
  renderShowAllSwitch() {
    const { t, user } = this.props;
    const { companiesOfWhiteBrand, domain } = this.state;
    const canSeeAll =
      user &&
      user.roles &&
      !companiesOfWhiteBrand &&
      domain !== "movImagen" &&
      (hasAccessRole(user.roles, [UserRoleEnum.companyMember]) ||
        user.is_in_media_holding);
    if (!canSeeAll) return null;
    return (
      <Tooltip title={t("Show all")}>
        <Switch
          size="small"
          defaultChecked={this.props.showAllDisplays}
          checked={this.props.showAllDisplays}
          onChange={this.toggleAllDisplays}
        />
      </Tooltip>
    );
  }

  renderViewModeSwitch() {
    const { t } = this.props;
    const isClusterMode = this.props.displaysMapMode === "cluster";
    return (
      <Radio.Group
        value={this.state.viewMode}
        onChange={this.handleChangeViewMode}
        buttonStyle="solid"
      >
        <Radio.Button value="map">
          <Icon type="environment" /> {t("Map")}
        </Radio.Button>
        <Tooltip
          title={isClusterMode ? t("Zoom in to see the screens in a table") : ""}
        >
          <Radio.Button value="table" disabled={isClusterMode}>
            <Icon type="table" /> {t("Table")}
          </Radio.Button>
        </Tooltip>
      </Radio.Group>
    );
  }

  renderResultsTable() {
    return (
      <TableResultsMap
        displaysMap={this.props.displaysMap}
        displaysMapMode={this.props.displaysMapMode}
        displays={this.props.displays}
        getDisplays={this.props.getDisplays}
        date_from={this.props.date_from}
        date_to={this.props.date_to}
        client={this.props.client}
        dsp={this.props.dsp}
        currency={this.props.currency}
        programmatic={this.props.programmatic}
        editCampaignActive={this.props.editCampaignActive}
        campaignCurrency={this.props.campaignCurrency}
        campaignInvoiceIssuingCountry={this.props.campaignInvoiceIssuingCountry}
        invoiceIssuingCountry={this.props.invoiceIssuingCountry}
        isGuaranteed={this.props.isGuaranteed}
        user={this.props.user}
        cart={this.props.cart}
        listBundle={this.props.listBundle}
        fetchingDisplaysMap={this.props.fetchingDisplaysMap}
        fetchingCart={this.props.fetching}
        addDisplayToCart={this.handleAddDisplayFromMap}
        getDisplaysCart={this.props.getDisplaysCart}
        getBulkDisplaysCart={this.handleBulkDisplaysCart}
        removeDisplayFromCart={this.props.removeDisplayFromCart}
        removeDisplayFromCartBulk={this.props.removeDisplayFromCartBulk}
        sort={this.state.mapSort}
        sortDir={this.state.mapSortDir}
        onSortChange={this.handleTableSortChange}
      />
    );
  }

  render() {
    const { t, i18n, user, fetching } = this.props;
    const {
      address,
      searchPlace,
      arrayPolygon,
      checkSearchMap,
      companiesOfWhiteBrand,
      domain,
      advancedFilters,
    } = this.state;

    moment.locale(i18n.language);

    const stableBounds = this.getStableBounds();
    const stableCenter = this.getStableCenter();
    const stableDefaultCenter = this.getStableDefaultCenter();
    const displaysIdsLength = this.getDisplaysIdsLength();


    const isClusterMode = this.props.displaysMapMode === "cluster";

    return (
      <ErrorBoundary
        fallbackRender={({ error }) => (
          <CriticalErrorFallbackComponent error={error} />
        )}
      >
        <MapHolder>
          <CartContainer
            displays={this.state.displaysAudience}
            action={this.state.displaysAction}
            cleanArrayPolygon={this.cleanArrayPolygon}
            cleanFilters={this.cleanFilters}
            viewMode={this.state.viewMode}
            drawerVisible={this.state.cartDrawerVisible}
            onOpenDrawer={this.handleOpenCartDrawer}
            onCloseDrawer={this.handleCloseCartDrawer}
          />
          <Row className="searchResultsContainer" type="flex" justify="center">
            {this.state.isMobile ? (
              <Col
                className="resultMapContainerMobile"
                xs={24}
                sm={0}
                md={0}
                lg={0}
                xl={0}
              >
                <Row style={{ widht: "100%" }} type="flex" justify="end">
                  <div className="zonePickerContainer">
                    <div className="zonePicker">
                      <PlacesAutocomplete
                        value={this.state.address}
                        onChange={this.handleChangeAddress}
                        onSelect={this.handleSelectAddress}
                        searchOptions={{
                          componentRestrictions: {
                            // Google allows to put only 5 countries in this array
                            // country: ['ar', 'mx', 'es', 'gt', 'hn', 'ni', 'sv', 'bz', 'pa', 'cr', 'do']
                          },
                        }}
                      >
                        {({
                          getInputProps,
                          suggestions,
                          getSuggestionItemProps,
                          loading,
                        }) => (
                          <div>
                            <Dropdown
                              visible={this.state.address !== ""}
                              trigger={["click"]}
                              overlay={
                                <Menu>
                                  {loading && (
                                    <Menu.Item>{t("Loading")}...</Menu.Item>
                                  )}
                                  {suggestions.map((suggestion) => {
                                    return (
                                      <Menu.Item
                                        key={suggestion.id}
                                        {...getSuggestionItemProps(suggestion, {
                                          className: suggestion.active
                                            ? "suggestion-item--active"
                                            : "suggestion-item",
                                        })}
                                      >
                                        <span>{suggestion.description}</span>
                                      </Menu.Item>
                                    );
                                  })}
                                </Menu>
                              }
                            >
                              <Input
                                style={{ borderColor: Colors.primaryAccent }}
                                addonBefore={
                                  <div>
                                    <Icon type="search" />
                                    {t("Campaign location")}
                                  </div>
                                }
                                size="large"
                                placeholder="large size"
                                {...getInputProps({
                                  placeholder: t("Location, street or city"),
                                  className: "location-search-input",
                                })}
                              />
                            </Dropdown>
                            <CheckSearch
                              style={{ pointerEvents: "all", width: "40%" }}
                              className="customCheckStyle"
                            >
                              <span className="ant-checkbox-wrapper">
                                <Spin spinning={fetching}>
                                  <Checkbox
                                    onChange={this.setCheckSearchMap}
                                    defaultChecked={checkSearchMap}
                                    value={checkSearchMap}
                                  >
                                    {t("Search on move")}
                                  </Checkbox>
                                </Spin>
                              </span>
                            </CheckSearch>
                          </div>
                        )}
                      </PlacesAutocomplete>
                    </div>
                  </div>
                </Row>
                {/* Controles de vista en mobile: hasta ahora solo existian en la
                    columna de escritorio, asi que en telefono se perdian el
                    selector Mapa/Tabla y el switch "Mostrar todas". */}
                <Row
                  type="flex"
                  align="middle"
                  justify="space-between"
                  className="mobileViewControls"
                >
                  {this.renderShowAllSwitch()}
                  {this.renderViewModeSwitch()}
                </Row>
                {this.state.viewMode === "table" ? (
                  <div className="mobileTableWrapper">{this.renderResultsTable()}</div>
                ) : (
                <ResultsMap
                  bounds={stableBounds}
                  center={stableCenter}
                  defaultCenter={stableDefaultCenter}
                  user={this.props.user}
                  mapZoom={this.props.mapZoom}
                  setMapZoom={this.props.setMapZoom}
                  addDisplayToCart={this.handleAddDisplayFromMap}
                  addListDisplayToCart={this.props.addListDisplayToCart}
                  addDisplaysFromPolygon={this.handleAddDisplaysFromPolygon}
                  addClusterDisplaysFromPolygon={this.handleAddClusterDisplaysFromPolygon}
                  clusterPolygonLoading={this.props.clusterPolygonLoading}
                  updateArrayPolygon={this.updateArrayPolygon}
                  removeDisplaysFromPolygon={
                    this.handleRemoveDisplaysFromPolygon
                  }
                  shouldClearPolygons={this.state.shouldClearPolygons}
                  onPolygonsCleared={this.handlePolygonsCleared}
                  date_from={this.props.date_from}
                  date_to={this.props.date_to}
                  getAudience={this.props.getAudience}
                  cleanAudience={this.props.cleanAudience}
                  getDisplayInfoRequest={this.props.getDisplayInfoRequest}
                  removeDisplayFromCart={this.props.removeDisplayFromCart}
                  cart={this.props.cart}
                  setBounds={this.props.setBounds}
                  refreshDisplays={this.refreshDisplays}
                  displaysMap={this.props.displaysMap}
                  displaysMapMode={this.props.displaysMapMode}
                  relocateMap={this.state.relocateMap}
                  mapRelocated={this.mapRelocated}
                  searchLocationOff={this.searchLocationOff}
                  searchLocation={this.state.searchLocation}
                  loadingElement={RESULTS_MAP_LOADING_ELEMENT}
                  mapElement={RESULTS_MAP_ELEMENT_BORDERED}
                  hoverDisplay={this.state.hoverDisplay}
                  currentDisplay={this.state.currentDisplay}
                  currency={this.props.currency}
                  openDisplay={this.openDisplay}
                  closeDisplay={this.closeDisplay}
                  programmatic={this.props.programmatic}
                  editCampaignActive={this.props.editCampaignActive}
                  editCampaign={this.props.editCampaign}
                  searchPlace={searchPlace}
                  listBundle={this.props.listBundle}
                  initialBackup={this.props.initialBackup}
                  hasInitialBackup={this.props.hasInitialBackup}
                  containerElement={RESULTS_MAP_CONTAINER_MOBILE}
                />
                )}
              </Col>
            ) : null}
            <div className="programmaticSection">
              <CartAudienceContainer viewMode={this.state.viewMode} />
            </div>
            <Col className="listContainer" xs={24} sm={8} md={8} lg={8} xl={8}>
              <div
                className={
                  this.state.viewMode === "table" ? "listPanelBounded" : undefined
                }
              >
              <div className="positionAbs">
                <SelectionFiltersContainer
                  refreshDisplays={this.refreshDisplays}
                  openDisplay={this.openDisplay}
                  setAdvancedFilters={this.setAdvancedFilters}
                  advancedFilters={this.state.advancedFilters}
                />

                  {this.state.viewMode === "table" ? null : (
                    <Card
                      style={{
                        marginTop: "10px",
                        borderRadius: "16px",
                        marginBottom: "3px",
                        border: `1px solid ${Colors.borderStrong}`,
                      }}
                      bodyStyle={{ padding: "12px" }}
                    >
                      <div style={{ marginBottom: "10px", fontWeight: "bold", color: Colors.black }}>
                        {t("Screens")}
                      </div>

                      <Divider style={{ margin: "5px 0px" }}>
                        {this.props.fetchingDisplaysMap ? (
                          <span className="screensQuantity">
                            {t("Getting results")}
                          </span>
                        ) : (
                          <span className="screensQuantity">
                            {displaysIdsLength} {t("screen")}
                            {displaysIdsLength === 1 ? "" : "s"}
                          </span>
                        )}
                      </Divider>
                      <Row
                        display="flex"
                        className="searchSection"
                        gutter={8}
                        align="middle"
                      >
                        <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                          <Input
                            prefix={
                              <Icon
                                type="search"
                                style={{ color: Colors.textMuted }}
                              />
                            }
                            placeholder={t("Search")}
                            className="searchInput"
                            value={this.state.search || ""}
                            onChange={this.searchDisplays}
                          />
                        </Col>

                        <Col
                          xs={12}
                          sm={12}
                          md={12}
                          lg={12}
                          xl={12}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "flex-end",
                            gap: "8px",
                          }}
                        >
                          <Badge
                            count={this.alertBadge()}
                            style={{
                              backgroundColor: Colors.atention,
                              top: -1,
                              right: 5,
                            }}
                          >
                            <Button
                              type="primary"
                              className="buttonPrimary"
                              onClick={this.handleShowFiltersModal}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "5px",
                              }}
                            >
                              {t("Filters")} <Icon type="filter" />
                            </Button>
                          </Badge>
                        </Col>
                      </Row>
                    </Card>
              )}
              </div>
              {this.state.isMobile ? (
                <div
                  style={{
                    width: "100%",
                    textAlign: "center",
                    position: "absolute",
                  }}
                >
                  <Icon className="lineSepareteIcon" type="line" />
                </div>
              ) : null}
              {this.state.viewMode === "map" ? (
                <DisplayMapList
                  user={this.props.user}
                  countries={this.props.countries}
                  setCountries={this.props.setCountries}
                  fetchingDisplaysMap={this.props.fetchingDisplaysMap}
                  displaysMap={this.props.displaysMap}
                  displaysMapMode={this.props.displaysMapMode}
                  displays={this.props.displays}
                  getDisplays={this.props.getDisplays}
                  date_from={this.props.date_from}
                  date_to={this.props.date_to}
                  client={this.props.client}
                  dsp={this.props.dsp}
                  currency={this.props.currency}
                  programmatic={this.props.programmatic}
                  editCampaignActive={this.props.editCampaignActive}
                  campaignCurrency={this.props.campaignCurrency}
                  campaignInvoiceIssuingCountry={
                    this.props.campaignInvoiceIssuingCountry
                  }
                  invoiceIssuingCountry={this.props.invoiceIssuingCountry}
                  isGuaranteed={this.props.isGuaranteed}
                  currentDisplay={this.state.currentDisplay}
                  onOpenDisplay={this.openDisplay}
                  onHoverDisplay={this.hoverDisplay}
                />
              ) : (
                <div
                  className="filtersScroll"
                  style={{
                    padding: "0 12px",
                    overflowY: "auto",
                    flex: 1,
                    minHeight: 0,
                  }}
                >
                  <RefinateFiltersContainer
                    variant="table"
                    onApply={this.setAdvancedFilters}
                    initialValues={advancedFilters}
                    search={this.state.search || ""}
                    onSearchChange={this.setSearch}
                    programmatic={this.props.programmatic}
                    currency={this.props.editCampaignActive ? this.props.campaignCurrency : this.props.currency}
                  />
                </div>
              )}
              </div>
            </Col>
            {!this.state.isMobile ? (
              <Col
                className="resultMapContainer"
                xs={0}
                sm={16}
                md={16}
                lg={16}
                xl={16}
              >
                <div className="visualizationSector">
                  <div className="visualizationHeader">
                    <div className="visualizationHeaderLeft">
                      <div className="searchInput">
                        {/* SearchBox: Google Places location autocomplete */}
                        <PlacesAutocomplete
                          value={address}
                          onChange={this.handleChangeAddress}
                          onSelect={this.handleSelectAddress}
                        >
                          {({
                            getInputProps,
                            suggestions,
                            getSuggestionItemProps,
                            loading,
                          }) => (
                            <div>
                              <Dropdown
                                visible={address !== ""}
                                trigger={["click"]}
                                overlay={
                                  <Menu>
                                    {loading && (
                                      <Menu.Item>{t("Loading")}...</Menu.Item>
                                    )}
                                    {suggestions.map((suggestion) => (
                                      <Menu.Item
                                        key={suggestion.id}
                                        {...getSuggestionItemProps(suggestion, {
                                          className: suggestion.active
                                            ? "suggestion-item--active"
                                            : "suggestion-item",
                                        })}
                                      >
                                        <span>{suggestion.description}</span>
                                      </Menu.Item>
                                    ))}
                                  </Menu>
                                }
                              >
                                <Input
                                  prefix={
                                    <Icon
                                      type="search"
                                      style={{ color: Colors.textMuted }}
                                    />
                                  }
                                  {...getInputProps({
                                    placeholder: t("Search by city, place, region..."),
                                    className: "location-search-input",
                                  })}
                                />
                              </Dropdown>
                            </div>
                          )}
                        </PlacesAutocomplete>
                      </div>
                      {this.renderShowAllSwitch()}
                    </div>
                    {this.state.viewMode === "table" ? (
                      <CartTableSummaryButton
                        cart={this.props.cart}
                        audience={this.props.audience}
                        loadingAudience={this.props.loadingAudience}
                        programmatic={this.props.programmatic}
                        amountBudget={this.props.amountBudget}
                        date_from={this.props.date_from}
                        date_to={this.props.date_to}
                        onClick={this.handleOpenCartDrawer}
                      />
                    ) : null}
                    {this.renderViewModeSwitch()}
                  </div>
                  <div className="visualizationContent">
                    {this.state.viewMode === "map" ? (
                  <>
                    <MapFiltersComponent
                      t={t}
                      setPoiFilters={this.props.setPoiFilters}
                      refreshDisplays={this.refreshDisplays}
                      resetPoiFilters={this.props.resetPoiFilters}
                      poiFilters={this.props.poi_filters}
                      searchPlace={searchPlace}
                      handleSelectPlace={this.handleSelectPlace}
                      setCheckSearchMap={this.setCheckSearchMap}
                      checkSearchMap={this.state.checkSearchMap}
                      fetching={this.props.fetching}
                      onOpenAddByIdModal={this.handleOpenAddByIdModal}
                    />
                    <ResultsMap
                      bounds={stableBounds}
                      center={stableCenter}
                      defaultCenter={stableDefaultCenter}
                      user={this.props.user}
                      mapZoom={this.props.mapZoom}
                      setMapZoom={this.props.setMapZoom}
                      addDisplayToCart={this.handleAddDisplayFromMap}
                      addListDisplayToCart={this.props.addListDisplayToCart}
                      addDisplaysFromPolygon={this.handleAddDisplaysFromPolygon}
                      addClusterDisplaysFromPolygon={this.handleAddClusterDisplaysFromPolygon}
                      clusterPolygonLoading={this.props.clusterPolygonLoading}
                      date_from={this.props.date_from}
                      date_to={this.props.date_to}
                      getAudience={this.props.getAudience}
                      cleanAudience={this.props.cleanAudience}
                      removeDisplayFromCart={this.props.removeDisplayFromCart}
                      cart={this.props.cart}
                      setBounds={this.props.setBounds}
                      refreshDisplays={this.refreshDisplays}
                      displaysMap={this.props.displaysMap}
                      displaysMapMode={this.props.displaysMapMode}
                      relocateMap={this.state.relocateMap}
                      mapRelocated={this.mapRelocated}
                      searchLocationOff={this.searchLocationOff}
                      searchLocation={this.state.searchLocation}
                      loadingElement={RESULTS_MAP_LOADING_ELEMENT}
                      mapElement={RESULTS_MAP_ELEMENT_BORDERED}
                      hoverDisplay={this.state.hoverDisplay}
                      currentDisplay={this.state.currentDisplay}
                      currency={this.props.currency}
                      openDisplay={this.openDisplay}
                      closeDisplay={this.closeDisplay}
                      programmatic={this.props.programmatic}
                      editCampaignActive={this.props.editCampaignActive}
                      editCampaign={this.props.editCampaign}
                      containerElement={RESULTS_MAP_CONTAINER_DESKTOP}
                      searchPlace={searchPlace}
                      arrayPolygon={arrayPolygon || []}
                      updateArrayPolygon={this.updateArrayPolygon}
                      removeDisplaysFromPolygon={
                        this.handleRemoveDisplaysFromPolygon
                      }
                      shouldClearPolygons={this.state.shouldClearPolygons}
                      onPolygonsCleared={this.handlePolygonsCleared}
                      listBundle={this.props.listBundle}
                      initialBackup={this.props.initialBackup}
                      hasInitialBackup={this.props.hasInitialBackup}
                    />
                  </>
                ) : (
                      this.renderResultsTable()
                    )}
                  </div>
                </div>
              </Col>
            ) : null}
          </Row>

          <Modal
            title={t("Refinate your search")}
            visible={this.state.showFiltersModal}
            onCancel={this.handleCancelFiltersModal}
            footer={null}
            width={window.innerWidth > 768 ? "73%" : "80%"}
          >
            <RefinateFiltersContainer
              variant="map"
              onApply={this.setAdvancedFilters}
              initialValues={advancedFilters}
              search={this.state.search || ""}
              onSearchChange={this.setSearch}
              programmatic={this.props.programmatic}
              currency={this.props.editCampaignActive ? this.props.campaignCurrency : this.props.currency}
            />
          </Modal>

          <AddDisplaysByIdModal
            visible={this.state.showAddByIdModal}
            onCancel={this.handleCloseAddByIdModal}
            loading={this.props.checkingDisplaysByIds}
            result={this.props.checkDisplaysByIdsResult}
            user={this.props.user}
            setShouldPromptLogin={this.props.setShouldPromptLogin}
            checkDisplaysByIds={this.props.checkDisplaysByIds}
            date_from={this.props.date_from}
            date_to={this.props.date_to}
            editCampaignActive={this.props.editCampaignActive}
            currency={this.props.currency}
            campaignCurrency={this.props.campaignCurrency}
            invoiceIssuingCountry={this.props.invoiceIssuingCountry}
            campaignInvoiceIssuingCountry={this.props.campaignInvoiceIssuingCountry}
            client={this.props.client}
            programmatic={this.props.programmatic}
            dsp={this.props.dsp}
            isGuaranteed={this.props.isGuaranteed}
          />

          <BundlesAddedModal
            visible={!!this.state.bundlesAdded}
            bundles={this.state.bundlesAdded}
            programmatic={this.props.programmatic}
            currency={
              this.props.editCampaignActive
                ? this.props.campaignCurrency
                : this.props.currency
            }
            onClose={this.handleCloseBundlesAddedModal}
          />
        </MapHolder>
      </ErrorBoundary>
    );
  }
}

const Extended = withTranslation()(MapComponent);
Extended.static = MapComponent.static;

export default withRouter(Extended);
